// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'; // GOV.UK styles
import './styles/index.css'; // Optional: any global CSS you need

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
